import React from "react";
function Header() {
  return (
    <div>
      <h1>Kyle Feldmans Portfolio</h1>
      <h3>UI-Focused Full Stack Web Developer with skills in layout and design!</h3>
      <br />
      <div></div>
    </div>
  );
}

export default Header; 
